/**
 * Blog Post Custom JS — Copper Bridge USA
 * Progress bar, sticky shop bar, FAQ accordion, live product cards
 * Safe to load on all article pages (null-checks all elements)
 */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Progress Bar ── */
  var progressBar = document.getElementById('progress-bar');
  if (progressBar) {
    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      progressBar.style.width = scrollPercent + '%';
    });
  }

  /* ── Sticky Shop Bar ── */
  var stickyBar = document.getElementById('sticky-bar');
  var stickyClose = document.getElementById('sticky-close');
  if (stickyBar) {
    var stickyDismissed = false;
    window.addEventListener('scroll', function () {
      if (stickyDismissed) return;
      if (window.pageYOffset > 600) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    });
    if (stickyClose) {
      stickyClose.addEventListener('click', function () {
        stickyDismissed = true;
        stickyBar.classList.remove('visible');
      });
    }
  }

  /* ── FAQ Accordion ── */
  var faqQuestions = document.querySelectorAll('.faq-question');
  if (faqQuestions.length > 0) {
    faqQuestions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = this.parentElement;
        var isOpen = parent.classList.contains('active');

        // Close all other FAQ items
        document.querySelectorAll('.faq-item.active').forEach(function (item) {
          item.classList.remove('active');
        });

        // Toggle clicked item
        if (!isOpen) {
          parent.classList.add('active');
        }
      });
    });
  }

  /* ── Live Product Cards ──
   * Article HTML provides a product handle and readable fallback content.
   * This enhancement replaces only the live image/title/price/availability slots.
   */
  var articleTemplate = document.querySelector('.article-template[data-cb-product-json-root]');
  var productCards = document.querySelectorAll('.cb-blog-product-card[data-product-handle]');

  if (articleTemplate && productCards.length > 0 && window.fetch) {
    var productRoot = articleTemplate.getAttribute('data-cb-product-json-root') || '/products/';
    var moneyFormat = articleTemplate.getAttribute('data-cb-money-format') || '${{amount}}';
    var productRequests = {};

    var formatWithDelimiters = function (cents, precision, thousands, decimal) {
      var value = Number(cents);
      if (!Number.isFinite(value)) return '';

      var parts = (value / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    };

    var formatMoney = function (cents) {
      var tokenMatch = moneyFormat.match(/{{\s*(amount(?:_no_decimals)?(?:_with_comma_separator)?)\s*}}/);
      var token = tokenMatch ? tokenMatch[1] : 'amount';
      var formatted;

      if (token === 'amount_no_decimals') {
        formatted = formatWithDelimiters(cents, 0, ',', '.');
      } else if (token === 'amount_with_comma_separator') {
        formatted = formatWithDelimiters(cents, 2, '.', ',');
      } else if (token === 'amount_no_decimals_with_comma_separator') {
        formatted = formatWithDelimiters(cents, 0, '.', ',');
      } else {
        formatted = formatWithDelimiters(cents, 2, ',', '.');
      }

      return tokenMatch ? moneyFormat.replace(tokenMatch[0], formatted) : '$' + formatted;
    };

    var getProduct = function (handle) {
      if (!productRequests[handle]) {
        productRequests[handle] = fetch(productRoot + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Product request failed');
          return response.json();
        });
      }
      return productRequests[handle];
    };

    productCards.forEach(function (card) {
      var handle = (card.getAttribute('data-product-handle') || '').trim();
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) {
        card.classList.add('cb-blog-product-card--fallback');
        return;
      }

      card.setAttribute('aria-busy', 'true');
      getProduct(handle)
        .then(function (product) {
          var titleSlot = card.querySelector('[data-cb-product-title]');
          var mediaSlot = card.querySelector('[data-cb-product-media]');
          var priceSlot = card.querySelector('[data-cb-product-price]');
          var availabilitySlot = card.querySelector('[data-cb-product-availability]');
          var productLinks = card.querySelectorAll('[data-cb-product-link]');
          var productUrl = product.url || productRoot + handle;
          var featuredImage = product.featured_image;

          if (featuredImage && typeof featuredImage === 'object') featuredImage = featuredImage.src;

          if (titleSlot && product.title) titleSlot.textContent = product.title;
          if (priceSlot && Number.isFinite(Number(product.price))) {
            priceSlot.textContent = product.price_varies
              ? 'From ' + formatMoney(product.price)
              : formatMoney(product.price);
          }
          if (availabilitySlot) {
            availabilitySlot.textContent = product.available ? 'Available to order' : 'Currently unavailable';
            availabilitySlot.classList.toggle('is-unavailable', !product.available);
          }
          if (mediaSlot && featuredImage) {
            var image = document.createElement('img');
            image.src = featuredImage;
            image.alt = product.title || 'Copper Bridge welding product';
            image.loading = 'lazy';
            image.width = 320;
            image.height = 320;
            mediaSlot.replaceChildren(image);
          }
          productLinks.forEach(function (link) {
            link.href = productUrl;
          });

          card.classList.add('cb-blog-product-card--ready');
        })
        .catch(function () {
          card.classList.add('cb-blog-product-card--fallback');
        })
        .finally(function () {
          card.removeAttribute('aria-busy');
        });
    });
  }

});
